export default "__VITE_ASSET__CUdW6VDk__"